export function removeEmpty(obj) {
  if (obj) {
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null))
  }
  return obj
}
